// Authors: Delaney Gillilan
// Icon: ion:checkmark-round
// Slug: Set all signals that match the signal path
// Description: Set all signals that match one or more space-separated paths in which `*` can be used as a wildcard

import type { ActionPlugin, RuntimeContext } from '../../../engine/types'
import { updateLeaves } from '../../../utils/paths'

export const SetAll: ActionPlugin = {
  type: 'action',
  name: 'setAll',
  fn: (
    { merge, filtered }: RuntimeContext,
    include: string,
    newValue: any,
    exclude = /(?!)/,
  ) => {
    const masked = filtered({ include, exclude })
    updateLeaves(masked, () => newValue)
    merge(masked)
  },
}
